import React, {
    useEffect,
    useMemo,
    useCallback,
    useState,
    useRef,
} from "react";
import "bootstrap/dist/css/bootstrap.css";
import ContactLoader from "views/ContantLoader";
import "bootstrap/dist/css/bootstrap.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Table from "../../Table";
import { useSelector, useDispatch } from "react-redux";
import { getTasks } from "api/SalesApi";
import PersonDetailsTable from "views/Accounts/PersonDetails/PersonDetailsTable";
import CreateTaskModal from "views/Accounts/PersonDetails/CreateTaskModal"
import { createTaskAPI, updateTaskByIdApi } from "api/SalesApi"
import { getAllUsers } from "api/UsersApi"
import { setSearchEvent } from "ReduxStore/Slices/salesSlice"
import "./tasks.css"
import $ from 'jquery'

export default function TaskTab({ tasktab }) {
    const [dataApi, setDataApi] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editTask, setEditTask] = useState(false);
    const [taskId, setTaskId] = useState('');
    const [assignee, setAssignee] = useState([]);
    const dispatch = useDispatch();
    const { searchEvent } = useSelector((state) => state.salesSetter.tasks)
    const searchText = useRef("");
    const assigneeValue = useRef("");
    const columns = useMemo(
        () => [
            {
                Header: "",
                accessor: "status",
                className: "task_status",
                maxWidth: 80,
                minWidth: 80,
                width: 80,
                Cell: ({ cell }) => {
                    const status = cell.row.original.status

                    if (status == 'active')
                        return status == 'active' && <i title="active"
                            className="far fa-check-circle"
                            style={{ color: "grey", fontSize: "20px", cursor: 'pointer' }}
                            onClick={(e) => {
                                e.stopPropagation();

                                handleUpdateTask(cell.row.original.id, { status: 'completed' })
                            }}
                        ></i>
                    else if (status == 'completed')
                        return <i title="completed"
                            className="far fa-check-circle"
                            style={{ color: "#00BE5F", fontSize: "20px", cursor: 'pointer' }}
                            onClick={(e) => {
                                e.stopPropagation();

                                handleUpdateTask(cell.row.original.id, { status: 'active' })

                            }}
                        ></i>
                    else if (status == 'overdue')
                        return <i title="overdue"
                            className="far fa-check-circle"
                            style={{ color: "#F04438", fontSize: "20px", cursor: 'pointer' }}
                            onClick={(e) => {
                                e.stopPropagation();

                                handleUpdateTask(cell.row.original.id, { status: 'completed' })

                            }}
                        ></i>
                }

                ,
            },
            {
                Header: "Task Name",
                accessor: "title",
            },
            {
                Header: "Assignee",
                accessor: "assignee.name",
            },
            {
                Header: "Contact",
                accessor: "contact",
            },
            {
                Header: "Deal",
                accessor: "deal",
            },
            {
                Header: "Type",
                accessor: "type",
            },
            {
                Header: "Due Date",
                accessor: "dueDateTime",
                maxWidth: 230,
                minWidth: 230,
                width: 230,
            },
            {
                maxWidth: 80,
                minWidth: 80,
                width: 80,
                Header: "",
                accessor: "name_2",
                Cell: ({ cell }) => (
                    <OverlayTrigger
                        delay={{ hide: 50, show: 50 }}
                        placement="top"
                        key="top"
                        overlay={(props) => (
                            <Tooltip id="tooltip-top" {...props}>
                                Edit Task
                            </Tooltip>
                        )}
                    >
                        <i
                            className="fa fa-edit"
                            style={{ color: "gray", fontSize: "20px" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setEditTask(true)
                                setTaskId("") // force rerender
                                setTaskId(cell.row.original.id)
                            }}
                            data-toggle='modal'
                            data-target={
                                `#createTask`
                            }
                        ></i>
                    </OverlayTrigger>
                ),
            },
            {
                maxWidth: 80,
                minWidth: 80,
                width: 80,
                Header: "",
                accessor: "name_3",
                Cell: ({ cell }) => (
                    <OverlayTrigger
                        delay={{ hide: 50, show: 50 }}
                        placement="top"
                        key="top"
                        overlay={(props) => (
                            <Tooltip id="tooltip-top" {...props}>
                                Delete Task
                            </Tooltip>
                        )}
                    >
                        <i
                            className="fa fa-trash"
                            style={{ color: "gray", fontSize: "20px" }}
                            onClick={(e) => {
                                e.stopPropagation();

                                handleUpdateTask(cell.row.original.id, { isDeleted: true })
                            }}

                        ></i>
                    </OverlayTrigger>
                ),
            },
        ],
        []
    );



    const getTaskStatus = (currentTaskStatus) => {
        let status = ''
        switch (currentTaskStatus) {
            case 'task_all':
                status = 'all'
                break;
            case 'task_due':
                status = 'dueToday'
                break;
            case 'task_overdue':
                status = 'overdue'
                break;
            case 'task_completed':
                status = 'completed'
                break;
            default:
                status = 'all'
                break;
        }
        return status

    }

    const queryString = ({
        pageSize,
        pageIndex,
        currentTaskStatus
    }) => {
        let extraQuery = {};
        let taskStatus = getTaskStatus(currentTaskStatus);
        if (taskStatus == 'all') {
            extraQuery = {
                limit: pageSize,
                offset: pageSize * ((pageIndex + 1) - 1),
            }
        }
        if (taskStatus == 'dueToday') {
            extraQuery = {
                limit: pageSize,
                offset: pageSize * ((pageIndex + 1) - 1),
                status: taskStatus,
            }
        }
        if (taskStatus == 'overdue') {
            extraQuery = {
                limit: pageSize,
                offset: pageSize * ((pageIndex + 1) - 1),
                status: taskStatus,
            }
        }
        if (taskStatus == 'completed') {
            extraQuery = {
                limit: pageSize,
                offset: pageSize * ((pageIndex + 1) - 1),
                status: taskStatus,
            }
        }
        return extraQuery

    }
    // let firstLetterCapitalize = s => s.replace(/./, c => c.toUpperCase())
    const fetchData = useCallback(async ({ pageSize, pageIndex, currentTaskStatus, event, e }) => {

        setLoading(true);
        const startRow = pageSize * pageIndex;
        const endRow = startRow + pageSize;
        console.log("DEMdede", getTaskTab(),currentTaskStatus)

        let qs = queryString({ pageSize, pageIndex, currentTaskStatus:currentTaskStatus })
        if (searchEvent == 'byAssignee' || event == 'byAssignee') {
            qs = { ...qs, assigneeId: assigneeValue.current.value || '' }
            // getTasks(qs).then(data => {
            //     setDataApi(data);
            //     setLoading(false);
            // })
        }
        if (searchEvent == 'search' || event == 'search') {
            qs = { ...qs, search: searchText.current.value || '' }
            // getTasks(qs).then(data => {
            //     setDataApi(data);
            //     setLoading(false);
            // })
        }
        //else {
        getTasks(qs).then(data => {
            data = data.map(t => {
                t.contact = t.person ? t.person.firstName + ' ' + t.person.lastName : ''
                t.deal = t.deal ? t.deal.name : ''
                return t
            })
            setDataApi(data);
            setLoading(false);
        })
        // }

    }, [tasktab, searchEvent]);

    const handleCreateTask = async (data) => {
        setLoading(true);
        let qs = queryString({ pageSize: 50, pageIndex: 0, currentTaskStatus: getTaskTab() })

        await createTaskAPI(data).then(async (res) => {
            await getTasks(qs).then(data => {
                data = data.map(t => {
                    t.contact = t.person ? t.person.firstName + ' ' + t.person.lastName : ''
                    t.deal = t.deal ? t.deal.name : ''
                    return t
                })
                setDataApi(data);
                setLoading(false);
            })
        })
    }
    function getTaskTab() {
        try {
            let tab = $('.nav-link.active')[1].href;
            if (tab.includes('task_all'))
                return 'task_all';
            if (tab.includes('task_due'))
                return 'task_due';
            if (tab.includes('task_overdue'))
                return 'task_overdue';
            if (tab.includes('task_completed'))
                return 'task_completed';
        } catch (e) { }
        return ''
    }
    const handleUpdateTask = async (id, data) => {
        // setLoading(true);
        let qs = queryString({ pageSize: 50, pageIndex: 0, currentTaskStatus: getTaskTab() })


        await updateTaskByIdApi(id, data).then(async (res) => {
            await getTasks(
                qs
            ).then(data => {
                data = data.map(t => {
                    t.contact = t.person ? t.person.firstName + ' ' + t.person.lastName : ''
                    t.deal = t.deal ? t.deal.name : ''
                    return t
                })
                setDataApi(data);
                //  setLoading(false);
                setEditTask(false); 
            })
        })
    }

    useEffect(() => {
        getAllUsers(100, 0).then(users => {
            setAssignee(users)
        })
        var url_string = window.location.href;
        var url = new URL(url_string);
        var id = url.searchParams.get("id");
        if (id) {
            setEditTask(true)

            setTaskId(id)

            try {
                $('#createTask').modal('show');
            } catch (e) { }


        }

    }, [])

    return (
        <div id='tasks'>
            <div className="header">
                <div className="searchbox">
                    <input placeholder='Search' className="form-control search-input mr-3"
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                // setSearchLoading(true);
                                dispatch(setSearchEvent("search"));
                                //assigneeValue.current.value = '';
                                fetchData({
                                    pageSize: 50,
                                    pageIndex: 0,
                                    currentTaskStatus: tasktab,
                                    event: "search",
                                    e: e.target.value,
                                });
                            }
                        }}
                        ref={searchText}
                    ></input>
                    <select
                        onChange={e => {
                            dispatch(setSearchEvent("byAssignee"))
                            //searchText.current.value = '';
                            fetchData({
                                pageSize: 50,
                                pageIndex: 0,
                                currentTaskStatus: tasktab,
                                event: "byAssignee",
                                e: e.target.value,
                            });
                        }}
                        ref={assigneeValue}
                    >
                        <option value=''>Select Assignee</option>
                        {assignee && assignee.map(user => {
                            return <option value={user.id}>{user.name}</option>
                        })}
                    </select>
                </div>
                <a
                    className="lg_btn primary mr-2"
                    data-toggle='modal'
                    data-target={
                        `#createTask`
                    }
                    onClick={() => {
                        setEditTask(false)
                    }}
                    style={{ cursor: 'pointer', fontSize: '13px', lineHeight: '12px' }}
                >
                    <span>
                        <i className="fas fa-plus mr-2"></i>
                    </span>
                    Create Task
                </a>
            </div>
            <PersonDetailsTable
                columns={columns}
                data={dataApi}
                fetchData={fetchData}
                pageCount={10}
                loading={loading}
                currentTaskStatus={tasktab}
                onRowClick={(e, row) => {
                    setEditTask(true);
                    setTaskId(row.original.id);
                    try {
                        $('#createTask').modal('show');
                    } catch (e) { }
                 }}
            ></PersonDetailsTable>
            <CreateTaskModal userFlow={'fromMainMenu'} handleUpdateTask={handleUpdateTask} handleCreateTask={handleCreateTask} taskId={taskId} editTask={editTask} setEditTask={setEditTask} />
        </div>
    );
}
